import React, { useState, useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';

const DevDocs = () => {

    return (
        <>
            <Helmet>
                <title>Developer documentation - SMS Serwis</title>
            </Helmet>

            <div className="grid grid-cols-1 gap-6">


                {/* API Usage Documentation */}
                <div className="bg-white rounded-lg shadow p-6">
                    <h2 className="text-lg font-medium text-gray-900 mb-4">DEVELOPER üçin API ulanyş gollanmasy</h2>

                    <div className="prose max-w-none">
                        <h3 className="text-md font-medium text-gray-800">SMS ugratmak üçin API</h3>
                        <p className="text-sm text-gray-600">
                            Aşakdaky endpointleri ulanmak arkaly SMS ugradyp bilersiňiz:
                        </p>

                        <div className="my-4">
                            <h4 className="text-sm font-medium text-gray-700">HTTP Metody we URL</h4>
                            <div className="bg-gray-100 p-2 rounded">
                                <code className="text-sm">POST {window.location.origin.replace(/:3000|:3001/, '')}/api/send-sms</code>
                            </div>
                        </div>

                        {/* <div className="my-4">
                            <h4 className="text-sm font-medium text-gray-700">Headers</h4>
                            <div className="bg-gray-100 p-2 rounded">
                                <code className="text-sm">
                                    Content-Type: application/json<br />
                                    Authorization: Bearer SIZIŇ_API_TOKEN
                                </code>
                            </div>
                        </div> */}

                        <div className="my-4">
                            <h4 className="text-sm font-medium text-gray-700">Request Body</h4>
                            <div className="bg-gray-100 p-2 rounded">
                                <pre className="text-sm"><code>{`{
  "token-user": "YOU_TOKEN", // token
  "number": "64279765",  // 8 simwoldan ybarat telefon belgisi
  "message": "SMS habary"     // Ugradyljak tekst
}`}</code></pre>
                            </div>
                        </div>

                        <div className="my-4">
                            <h4 className="text-sm font-medium text-gray-700">Üstünlikli jogap</h4>
                            <div className="bg-gray-100 p-2 rounded">
                                <pre className="text-sm"><code>{`{
  "success": true,
  "message": "SMS kabul edildi",
  "smsId": "123456789",
  "status": "nosend"
}`}</code></pre>
                            </div>
                        </div>

                        <div className="my-4">
                            <h4 className="text-sm font-medium text-gray-700">Säwlikli jogap</h4>
                            <div className="bg-gray-100 p-2 rounded">
                                <pre className="text-sm"><code>{`{
  "success": false,
  "message": "Säwlik sebäbi"
}`}</code></pre>
                            </div>
                        </div>

                        <p className="text-sm text-gray-600 mt-4">
                            Bellik: Her bir SMS ugratmak üçin 0.50 TMT töleg alynýar. Balans ýeterlikli bolmasa, SMS kabul edilýär
                            emma statusy "nobalance" görnüşde bellenilýär we balans ýetmezçiliginde duran SMS-leriň ählisi bellenilen wagt aralygynda sistemadan pozulýar.
                        </p>

                        <div className="my-4">
                            <h4 className="text-sm font-medium text-gray-700">SMS-iň statusyny barlamak</h4>
                            <div className="bg-gray-100 p-2 rounded">
                                <code className="text-sm">GET {window.location.origin.replace(/:3000|:3001/, '')}/api/sms/status/:smsId</code>
                            </div>
                            <p className="text-xs text-gray-500 mt-1">
                                Header-da Authorization tokeny görkezmeli
                            </p>
                        </div>

                        <div className="my-4">
                            <h4 className="text-sm font-medium text-gray-700">Mümkin bolan statuslar:</h4>
                            <ul className="list-disc list-inside text-sm text-gray-600">
                                <li><span className="font-medium">nosend</span> - SMS garaşýar</li>
                                <li><span className="font-medium">sent</span> - SMS ugradyldy</li>
                                <li><span className="font-medium">failed</span> - SMS ugradyp bolmady</li>
                                <li><span className="font-medium">nobalance</span> - Ýeterlik pul ýok</li>
                            </ul>
                        </div>

                        <div className="my-4">
                            <h4 className="text-sm font-medium text-gray-700">PHP-de mysal ulanylyşy</h4>
                            <div className="bg-gray-100 p-2 rounded">
                                <pre className="text-sm overflow-x-auto"><code>{`<?php
$apiToken = 'SIZIŇ_API_TOKEN';
$url = '${window.location.origin.replace(/:3000|:3001/, '')}/api/sms/send';

$data = array(
    'phoneNumber' => '64279765',
    'message' => 'Test habary'
);

$options = array(
    'http' => array(
        'header'  => "Content-Type: application/json\\r\\n" .
                     "Authorization: Bearer " . $apiToken . "\\r\\n",
        'method'  => 'POST',
        'content' => json_encode($data)
    )
);

$context  = stream_context_create($options);
$result = file_get_contents($url, false, $context);

if ($result === FALSE) {
    // Säwlik ýüze çykdy
} else {
    $response = json_decode($result, true);
    // Jogaby işläň
}
?>`}</code></pre>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </>
    );
};

export default DevDocs;